import qs from 'qs'
import { Link } from 'react-router-dom'

import './index.less'

const LayoutFooter = () => {
  const handleJumpURL = (url: string): string => {
    const channelSearch = sessionStorage.getItem('channelSearch') || ''
    const [, baseSearch] = window.location.pathname.split('?')

    const baseParams = qs.parse(baseSearch)
    const channelParams = qs.parse(
      channelSearch.startsWith('?') ? channelSearch.slice(1) : channelSearch
    )

    const paramsString = qs.stringify({
      ...channelParams,
      ...baseParams
    })
    const jumpURL = `${url}?${paramsString}`

    return jumpURL
  }

  return (
    <footer className="global-layout-footer">
      <div>
        <Link to={handleJumpURL('/about')} target="_blank" rel="noreferrer">
          About Us
        </Link>
        <Link
          to={handleJumpURL('/communityguidelines')}
          target="_blank"
          rel="noreferrer"
        >
          Community Guidelines
        </Link>
        <Link
          to={handleJumpURL('/termsofuse')}
          target="_blank"
          rel="noreferrer"
        >
          Terms of Use
        </Link>
        <Link
          to={handleJumpURL('/privacypolicy')}
          target="_blank"
          rel="noreferrer"
        >
          Privacy Policy
        </Link>
      </div>
      <div className="footer-info">&#169; 2024 Mespery Ltd</div>
    </footer>
  )
}

export default LayoutFooter
